<div class="container">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
